import { useSetAtom, useAtom, atom } from 'jotai';

export type MembershipTouAcceptancePayload = {
  userMembershipId: string;
  organizationId: string;
  clientId: string;
};

type MembershipTouAcceptanceState = MembershipTouAcceptancePayload | null;

const membershipTouAcceptanceAtom = atom<MembershipTouAcceptanceState>(null);

// Write-only, for the notification click handler (toast + notification
// center) and for the "existing client, first RECURRING membership" case
// right after `AssignMembershipDialog` succeeds — same shape as
// useSetMembershipCardSetup.
export const useSetMembershipTouAcceptance = () => {
  const setState = useSetAtom(membershipTouAcceptanceAtom);
  return (payload: MembershipTouAcceptancePayload) => setState(payload);
};

// Global (atom + AppLayout host, per useDailyActivityModalStore's
// precedent): unlike the card-setup flow (an external redirect), accepting
// Terms of Use IS an in-app dialog, so this store's `pending` directly
// drives that dialog's open state.
export const useMembershipTouAcceptanceStore = () => {
  const [state, setState] = useAtom(membershipTouAcceptanceAtom);
  return {
    clear: () => setState(null),
    pending: state,
  };
};
